import { useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const baseStyle = {
  cursor: 'pointer',
  color: '#ffffff',
  background: 'rgb(0,220,73)',
  borderRadius: '5px',
  padding: '0 4px',
};

const badgeStyle = {
  fontSize: '0.6em',
  lineHeight: 1,
  color: '#ffffff',
  fontWeight: 700,
  verticalAlign: 'super',
  marginLeft: '1px',
};

const popoverStyle = {
  position: 'fixed',
  width: '260px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  background: '#1a1a1a',
  border: '1px solid rgba(157,157,157,0.3)',
  borderRadius: '12px',
  padding: '10px 12px',
  boxShadow: '0 12px 32px rgba(0,0,0,0.5)',
  zIndex: 9999,
  textAlign: 'left',
};

const CitationHighlight = ({ source, onOpen, children }) => {
  const anchorRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [tip, setTip] = useState(null);

  const handleEnter = () => {
    setHovered(true);
    if (!source || !anchorRef.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    const top = Math.min(rect.bottom + 8, window.innerHeight - 140);
    const left = Math.max(140, Math.min(rect.left + rect.width / 2, window.innerWidth - 140));
    setTip({ top, left });
  };

  return (
    <span
      ref={anchorRef}
      style={baseStyle}
      onMouseEnter={handleEnter}
      onMouseLeave={() => { setHovered(false); setTip(null); }}
      onClick={() => { if (source) onOpen?.(source); }}>
      {children}
      {source?.number != null && (
        <span
          style={{
            ...badgeStyle,
            textShadow: hovered ? '0 0 8px rgba(0,220,73,0.8)' : 'none',
            transition: 'text-shadow 0.15s ease',
          }}>
          {source.number}
        </span>
      )}
      <AnimatePresence>
        {tip && source && (
          <motion.span
            initial={{ opacity: 0, y: 6, scale: 0.96, x: '-50%' }}
            animate={{ opacity: 1, y: 0, scale: 1, x: '-50%' }}
            exit={{ opacity: 0, y: 6, scale: 0.96, x: '-50%' }}
            transition={{ duration: 0.15 }}
            style={{ ...popoverStyle, top: tip.top, left: tip.left }}>
            <span style={{ fontSize: 11, color: 'rgb(154,170,184)', fontWeight: 600 }}>
              {source.domain || 'Source'}
            </span>
            <span
              style={{
                fontSize: 13, color: 'var(--ink)', lineHeight: 1.4,
                display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
              }}>
              {source.title}
            </span>
          </motion.span>
        )}
      </AnimatePresence>
    </span>
  );
};

export default CitationHighlight;
